export enum EOrderStatus {
  UNDEFINED = 'Undefined',
  CREATED = 'Created',
  SAVED = 'Saved',
  APPROVED = 'Approved',
  VOIDED = 'Voided',
  COMPLETED = 'Completed',
  PAYER_ACTION_REQUIRED = 'PayerActionRequired',
}
